<template>

    <div class="border border-pink-300 py-12 px-14">

        <Heading tag="h3" class="notice__header" v-html="title"/>

        <DynamicContent class="pt-8" :content="description"/>

    </div>

</template>

<script lang="ts">
    import { defineComponent } from 'vue'
    import Heading from './Heading.vue'
    import DynamicContent from './DynamicContent.vue'

    export default defineComponent({
        name: 'Notice',
        components: {
            Heading,
            DynamicContent
        },
        props: {
            title: { type: String, required: true },
            description: { type: Object, required: true }
        }
    })
</script>

<style lang="scss">

    @include component(notice) {

        @include part(header) {

            color: #FBA7F2 !important;

        }

    }

</style>
